export default {
  'dynamicEntityGroup.title': 'Manage Dynamic Entities Group',
  'dynamicEntityGroup.entities': 'Entities',
};
